type PhaseWithDuration = {
  id: string
  duration: number
}

const buildPhaseStarts = (phaseDurations: number[]) => {
  return phaseDurations.reduce<number[]>((starts, _duration, index) => {
    if (index === 0) {
      starts.push(0)
      return starts
    }
    starts.push(starts[index - 1] + phaseDurations[index - 1])
    return starts
  }, [])
}

export const getDefaultPhaseDurations = (phases: PhaseWithDuration[]) => {
  return phases.map((phase) => Math.max(phase.duration, 0))
}

export const resolveEffectivePhaseDurations = (
  phases: PhaseWithDuration[],
  persistedPhaseDurations: unknown,
) => {
  const persisted =
    typeof persistedPhaseDurations === 'object' &&
    persistedPhaseDurations !== null &&
    !Array.isArray(persistedPhaseDurations)
      ? persistedPhaseDurations
      : {}
  return phases.map((phase) => {
    const defaultDuration = Math.max(phase.duration, 0)
    const persistedDuration = (persisted as Record<string, unknown>)[phase.id]
    if (typeof persistedDuration !== 'number') return defaultDuration
    return Math.max(persistedDuration, 0)
  })
}

export const resolvePhaseTiming = ({
  phases,
  persistedPhaseDurations,
}: {
  phases: PhaseWithDuration[]
  persistedPhaseDurations: unknown
}) => {
  const defaultPhaseDurations = getDefaultPhaseDurations(phases)
  const effectivePhaseDurations = resolveEffectivePhaseDurations(
    phases,
    persistedPhaseDurations,
  )
  const defaultPhaseStarts = buildPhaseStarts(defaultPhaseDurations)
  const phaseStarts = buildPhaseStarts(effectivePhaseDurations)
  const phaseEnds = phaseStarts.map(
    (phaseStart, index) => phaseStart + (effectivePhaseDurations[index] ?? 0),
  )

  return {
    defaultPhaseDurations,
    effectivePhaseDurations,
    defaultPhaseStarts,
    phaseStarts,
    phaseEnds,
  }
}
